/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-05-10 21:35:56
 * @FilePath: \hippo-web-admin\src\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';

/**
 * 获取当前登录的用户信息
 */
export const getUserInfo = () => {
  return request({
    url: '/web/member/loadMyMemberInfo',
    method: 'post',
    data: {}
  })
}

/**
 * 获取当前登录的用户设备
 */
export const getUserDeviceInfo = (data) => {
  return request({
    url: '/web/device/getDeviceList',
    method: 'post',
    data: data
  }).then(res => {
    return res
  })
}

/**
 * 获取当前登录的用户设备
 */
export const getPdfDeviceInfo = ({queryMemberId, activeTime, deviceNo}) => {
  return request({
    url: '/web/userReport/loadDeviceDetail',
    method: 'post',
    data: { queryMemberId, activeTime, deviceNo }
  })
}


/**
 * 获取当前登录的用户信息
 */
export const uploadAvatar = (data) => {
  return request({
    url: '/web/uploadfile/uploadImage',
    method: 'post',
    data
  })
}

/**
 * 修改用户信息
 */
export const updateUserInfo = (data) => {
  return request({
    url: '/web/member/saveMemberInfo',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  })
}

/**
 * 修改当前登录的用户密码
 * @param data
 */
export async function updatePassword({ oldPassword, newPassword } = {}) {
  return request({
    url: '/web/user/modifyPassword',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { oldPassword, newPassword }
  })
}

/**
 * 获取当前登录用户预警信息
 * @param data
 */
export async function getAlarmInfo({ memberId } = {}) {
  return request({
    url: '/web/member/loadMyMemberSeting',
    method: 'post',
    data: { memberId }
  })
}

/**
 * 修改分享标识 /web/userFollower/modifyFollowerShareFlag
 */
export async function modifyFollowerShareFlag(followerId, shareFlag) {
  return request({
    url: '/web/userFollower/modifyFollowerShareFlag',
    method: 'post',
    data: { followerId, shareFlag }
  })
}

/**
 *移除follower
 */
export async function removeFollower(followerId) {
  return request({
    url: '/web/userFollower/delFollower',
    method: 'post',
    data: { followerId }
  })
}

/**
 * 同意follower
 */
export async function agreeFollower(followerRequestId) {
  return request({
    url: '/web/userFollower/agreedFollowerRequest',
    method: 'post',
    data: { followerRequestId }
  })
}

/**
 * 拒绝follower
 */
export async function rejectFollower(followerRequestId) {
  return request({
    url: '/web/userFollower/rejectFollowerRequest',
    method: 'post',
    data: { followerRequestId }
  })
}

/**
 * 获取用户血糖报告数据
 */
export async function getBloodSugarReportData(memberDeviceId) {
  return request({
    url: '/web/userReport/loadDeviceReport',
    method: 'post',
    data: { memberDeviceId }
  })
}